/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


export function getDismantler(data, schedule) {

    const _address = `${data.city_title}, ${data.address}, ${data.postalcode}, ${data.country_title}`;

    let dismantler = {
        address: _address,
        company: data.company,
        contact_choice: data.contact_choice,
        phone_code: data.phone_code,
        phone: data.phone,
        email: data.email,
        facebook: data.facebook || null,
        instagram: data.instagram || null,
        schedule: schedule || [],
        logo: data.logo
    };

    return dismantler;
}